<div class="modal-header">
  <h5 class="modal-title fw-bold">Update my news preferences</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body filter-scroll">

  <div class="cat-grid">
    <div class="cat-box" *ngFor="let cat of industries" (click)="toggleSelection(cat.id)"
      [class.active]="isChecked(cat.id)">

      <div class="check-icon">
        <input type="checkbox" [checked]="isChecked(cat.id)" class="hidden-checkbox" (change)="toggleSelection(cat.id)">
        <span class="icon"></span>
      </div>

      <span class="cat-label">{{ cat.name }}</span>
    </div>
  </div>

</div>

<div class="modal-footer">
  <!-- <button class="btn btn-light" (click)="close()">Cancel</button> -->
  <button class="btn btn-primary" (click)="save()">Save</button>
</div>